<template>
    <div class="d-flex flex-column justify-content-center font-size-110 mb-n2">
        <div v-if="isSale">
            <div
                class="d-flex align-items-center justify-content-between position-relative flex-wrap select-billing-item-wrapper cursor-pointer mb-4 py-2 br-8 border bg-premium-dark text-white"
            >
                <label
                    class="mb-0 py-2 px-3 d-inline-flex align-items-center justify-content-start select-billing-item font-weight-normal"
                >
                    <div class="d-inline-flex flex-row flex-wrap-reverse">
                        <div class="d-inline-flex flex-column mr-1 justify-content-center align-items-start">
                            <span class="font-weight-bold font-size-125 mb-3"> {{ 'Cyber Week Sale' | trans }}! </span>
                            <span class="font-weight-bold font-size-125 mb-3"> {{ 'Ends in' | trans }}: </span>
                            <span
                                class="font-weight-bold font-size-150 badge bg-warning mb-1 position-absolute text-normal top-0 mt-3"
                                style="right: 10px"
                            >
                                {{ 'Save %discount%' | trans({ '%discount%': '70%' }) }}
                            </span>
                            <div style="margin-left: -5px">
                                <flip-countdown class="p-0" :deadline="saleEnd"></flip-countdown>
                            </div>
                        </div>
                    </div>
                </label>
            </div>
        </div>

        <div v-if="isOc || showWeekPass" class="font-weight-bold mb-1">{{ 'One-Time Payment' | trans }}</div>

        <SelectBillingItem
            v-if="showWeekPass"
            :disabled="disabled"
            :enable-learn-more="true"
            :learn-more-texts="learnMoreTextsWeek"
            item-value="week"
            name="week"
            v-model="selectedBilling"
            class="mb-2 br-8 border bg-white"
            :class="{
                'outline-info': selectedBilling === 'week',
            }"
        >
            <span class="d-inline-flex flex-row flex-wrap-reverse">
                <span class="d-inline-flex flex-column mr-1 justify-content-center">
                    <span class="font-weight-bold font-size-125 mb-1">
                        {{ 'Week Pass' | trans }}
                    </span>
                    <span class="">
                        {{ priceStringWeekly }}
                    </span>
                </span>
            </span>
        </SelectBillingItem>

        <SelectBillingItem
            v-if="isOc"
            :disabled="disabled"
            :enable-learn-more="true"
            :learn-more-texts="learnMoreTextsDay"
            item-value="day"
            name="day"
            v-model="selectedBilling"
            class="mb-2 br-8 border bg-white"
            :class="{
                'outline-info': selectedBilling === 'day',
            }"
        >
            <span class="d-inline-flex flex-row flex-wrap-reverse">
                <span class="d-inline-flex flex-column mr-1">
                    <span class="font-weight-bold font-size-125 mb-1">
                        {{ '24h Pass' | trans }}
                    </span>
                    <span class="">
                        {{ priceStringDaily }}
                    </span>
                </span>
            </span>
        </SelectBillingItem>

        <div class="font-weight-bold mt-3 mb-1">{{ 'Subscriptions' | trans }}</div>

        <SelectBillingItem
            :disabled="disabled"
            :enable-learn-more="true"
            :learn-more-texts="learnMoreTextsMonth"
            item-value="month"
            name="month"
            v-model="selectedBilling"
            class="mb-2 br-8 border bg-white"
            :class="{
                'outline-info': selectedBilling === 'month',
            }"
        >
            <span class="d-inline-flex flex-row flex-wrap-reverse">
                <span class="d-inline-flex flex-column mr-1">
                    <span class="font-weight-bold font-size-125 mb-1">
                        {{ 'Monthly' | trans }}
                    </span>
                    <span class="">
                        {{ '%AMOUNT% / month' | trans({ '%AMOUNT%': priceStringMonthly }) }}
                    </span>
                </span>
            </span>
        </SelectBillingItem>

        <SelectBillingItem
            :disabled="disabled"
            :enable-learn-more="true"
            :learn-more-texts="learnMoreTextsYearSale"
            item-value="annual_%currency%_%version%_sale_cyberweek"
            name="annual"
            v-model="selectedBilling"
            class="mb-2 br-8 border bg-white"
            v-if="isSale"
            :class="{
                'outline-info': selectedBilling === 'annual',
            }"
        >
            <span class="d-inline-flex flex-row flex-wrap-reverse">
                <span class="d-inline-flex flex-column mr-1">
                    <span
                        class="font-weight-bold font-size-125 mb-1 ml-n2 mt-n1 d-inline-flex flex-wrap align-items-center"
                    >
                        <span class="ml-2_ mt-1">{{ 'Yearly' | trans }}</span>
                        <StolenGitLabBadge
                            label="Cyber Week Sale"
                            :value="saveBadgeText"
                            class="mt-1 ml-2_"
                        ></StolenGitLabBadge>
                    </span>
                    <span class="">
                        {{ '%AMOUNT% / month' | trans({ '%AMOUNT%': monthlyPriceForAnnualSale }) }}
                    </span>
                    <span class="text-muted">
                        <span v-html="billedAnnuallySale"></span>
                    </span>
                </span>
            </span>
        </SelectBillingItem>

        <SelectBillingItem
            v-if="!isSale"
            :disabled="disabled"
            :enable-learn-more="true"
            :learn-more-texts="learnMoreTextsYear"
            item-value="annual"
            name="annual"
            v-model="selectedBilling"
            class="mb-2 br-8 border bg-white"
            :class="{
                'outline-info': selectedBilling === 'annual',
            }"
        >
            <span class="d-inline-flex flex-row flex-wrap-reverse">
                <span class="d-inline-flex flex-column mr-1">
                    <span class="font-weight-bold font-size-125 mb-1 ml-n2 mt-n1 d-inline-flex flex-wrap">
                        <span class="ml-2_ mt-1">{{ 'Yearly' | trans }}</span>
                        <span
                            class="badge bg-info text-white my-0 ml-2_ mt-1 br-50 px-2 d-inline-flex align-self-center"
                        >
                            {{ 'Save %amount%' | trans({ '%amount%': amountSavedForAnnual }) }}
                        </span>
                    </span>
                    <span class="">
                        {{ '%AMOUNT% / month' | trans({ '%AMOUNT%': monthlyPriceForAnnual }) }}
                    </span>
                    <span class="text-muted">
                        {{ 'Billed %PRICE% annually' | trans({ '%PRICE%': priceStringYearly }) }}
                    </span>
                </span>
            </span>
        </SelectBillingItem>
    </div>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { translate } from '../../../../../qaamgo/helper/translate';
import { projectHelper } from '../../../../misc/project-helper';
import { pageStoreMixin } from '../../../../store/page-store';
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import { paymentManager } from '../../../../payment/payment-manager';
import SelectBillingItem from './SelectBillingItem';
import { satGlobals } from '../../../../../qaamgo/sat/helper/sat-globals';
import FlipCountdown from 'vue2-flip-countdown';
import StolenGitLabBadge from './StolenGitLabBadge';

export default {
    name: 'SelectBilling',
    components: { StolenGitLabBadge, SelectBillingItem, FlipCountdown },
    mixins: [TransFilter, pageStoreMixin],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        absoluteFileSizeLimit: {
            // formatted, localized, human-readable string of max total file size per job
            type: String,
            required: true,
        },
        currency: {
            type: String,
            required: true,
        },
        selectedSize: {
            type: String | null,
            required: true,
        },
        selectedProvider: {
            type: String,
            required: true,
        },
        trialData: {
            type: Object,
            default: {},
        },
    },
    beforeMount() {
        if (testIsNonEmptyString(this.selectedBillingStore)) {
            this.selectedBilling = this.selectedBillingStore;
            this.selectedProduct = this.selectedProductStore;
        }
    },
    watch: {
        selectedBilling(billing, oldBilling) {
            if (this.disabled) {
                this.selectedBilling = oldBilling;

                return;
            }

            this.store.userPaymentModal.setSelectedBilling(billing);
        },
        selectedBillingStore(billing) {
            if (this.selectedBilling !== billing) {
                this.selectedBilling = billing;
            }
        },
    },
    computed: {
        /** @return {Boolean} */
        isTrialEnabled() {
            return this.store.userPaymentModal.offerTrial;
        },
        isSale() {
            return this.store.userPaymentModal.isSale;
        },
        selectedBillingStore() {
            return this.store.userPaymentModal.selectedBilling;
        },
        selectedPlanStore() {
            return this.store.userPaymentModal.selectedPlan;
        },
        selectedProductStore() {
            return this.store.userPaymentModal.selectedProduct;
        },
        selectedQuotaStore() {
            return this.store.userPaymentModal.selectedQuota;
        },
        learnMoreTextsWeek() {
            let texts = [
                translate('Billed once'),
                translate('Valid for 1 week'),
                translate('<strong>Full and unlimited</strong> access to all our tools'),
            ];

            return texts;
        },
        learnMoreTextsYear() {
            let texts = [
                translate('Billed yearly'),
                translate('<strong>%amount%</strong> per month, paid yearly', {
                    '%amount%': this.monthlyPriceForAnnual,
                }),
                translate('Most common plan'),
            ];

            if (this.isTrialEnabled) {
                texts.push(
                    translate('You pay <strong>%amount%</strong> until <strong>%date%</strong>', {
                        '%amount%': this.trialData.priceAtTrialStart[this.currency],
                        '%date%': this.trialData.dateFirstChargeShort,
                    })
                );
            }

            texts.push(translate('<strong>Full and unlimited</strong> access to all our tools'));

            if (this.isOc) {
                texts.push(translate('Increased file size, select maximum with slider'));
            }

            return texts;
        },
        learnMoreTextsYearSale() {
            let texts = [
                translate('Billed yearly'),
                translate('<strong>%amount%</strong> per month, paid yearly for the first year', {
                    '%amount%': this.monthlyPriceForAnnualSale,
                }),
                translate('After the first year you pay %amount% annually', {
                    '%amount%': this.priceStringYearly,
                }),
            ];
            texts.push(translate('<strong>Full and unlimited</strong> access to all our tools'));

            if (this.isOc) {
                texts.push(translate('Increased file size, select maximum with slider'));
            }

            return texts;
        },
        learnMoreTextsMonth() {
            let texts = [translate('Billed monthly'), translate('Most flexible plan')];

            if (this.isTrialEnabled) {
                texts.push(
                    translate('You pay <strong>%amount%</strong> until <strong>%date%</strong>', {
                        '%amount%': this.trialData.priceAtTrialStart[this.currency],
                        '%date%': this.trialData.dateFirstChargeShort,
                    })
                );
            }
            texts.push(translate('<strong>Full and unlimited</strong> access to all our tools'));

            if (this.isOc) {
                texts.push(translate('Increased file size, select maximum with slider'));
            }

            return texts;
        },
        billedAnnuallySale() {
            return translate(
                '<span>Billed</span> <span style="text-decoration: line-through">%OLD_PRICE%</span> %PRICE% annually',
                {
                    '%OLD_PRICE%': this.priceStringYearly,
                    '%PRICE%': this.priceStringYearlySale,
                }
            );
        },
        learnMoreTextsDay() {
            return [
                translate('Valid for 24 hours'),
                translate('One time payment'),
                translate('Best for infrequent usage'),
                translate('<strong>Full and unlimited</strong> access to all our tools'),
                translate('Increased file size, select maximum with slider'),
            ];
        },
        priceStringWeekly() {
            if (!this.showWeekPass) {
                return '';
            }

            return this.getPriceStringForBillingAndProduct('week');
        },
        priceStringDaily() {
            if (!this.isOc) {
                return '';
            }

            let selectedSize = this.selectedSize;
            if (this.isOc && Number.parseInt(this.selectedSize) < 1000) {
                selectedSize = '1000';
            }

            return this.getPriceStringForBillingAndProduct('day', selectedSize);
        },
        priceStringMonthly() {
            if (projectHelper.isApi2Convert()) {
                return '';
            }

            if (satGlobals.isMultipleProductsEnabled()) {
                return this.getPriceStringForBillingAndProduct('month', this.selectedProductStore);
            }

            return this.getPriceStringForBillingAndProduct('month');
        },
        priceStringYearly() {
            if (projectHelper.isApi2Convert()) {
                return '';
            }

            if (satGlobals.isMultipleProductsEnabled()) {
                return this.getPriceStringForBillingAndProduct('annual', this.selectedProductStore);
            }

            return this.getPriceStringForBillingAndProduct('annual');
        },
        priceStringYearlySale() {
            if (projectHelper.isApi2Convert()) {
                return '';
            }

            return this.getPriceStringForBillingAndProduct('annual_%currency%_%version%_sale_cyberweek');
        },
        monthlyPriceForAnnual() {
            if (projectHelper.isApi2Convert()) {
                return '';
            }

            /** @type {PaymentData} */
            let paymentData = {};

            if (satGlobals.isMultipleProductsEnabled()) {
                paymentData = {
                    billing: 'annual',
                    product: this.selectedProductStore,
                    plan: 'individual'
                }
            } else if (satGlobals.isCreditsInAllSatsEnabled()) {
                paymentData = {
                    billing: 'annual',
                    product: this.selectedProductStore,
                    quota: this.selectedQuotaStore,
                    plan: 'individual'
                }
            } else {
                paymentData = {
                    billing: 'annual',
                    product: this.selectedSize,
                    provider: this.selectedProvider
                }
            }

            return paymentManager.getSlugHelper().getMonthlyPriceForAnnual(paymentData, this.currency);
        },
        monthlyPriceForAnnualSale() {
            if (projectHelper.isApi2Convert()) {
                return '';
            }

            /** @type {PaymentData} */
            const paymentData = {};

            paymentData.billing = 'annual_%currency%_%version%_sale_cyberweek';
            paymentData.product = this.selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getMonthlyPriceForAnnualSale(paymentData, this.currency);
        },
        amountSavedForAnnual() {
            if (projectHelper.isApi2Convert()) {
                return '';
            }

            /** @type {PaymentData} */
            let paymentData = {};

            if (satGlobals.isMultipleProductsEnabled()) {
                paymentData = {
                    billing: 'annual',
                    product: this.selectedProductStore,
                    plan: 'individual'
                }
            } else if (satGlobals.isCreditsInAllSatsEnabled()) {
                paymentData = {
                    billing: 'annual',
                    product: this.selectedProductStore,
                    quota: this.selectedQuotaStore,
                    plan: 'individual'
                }
            } else {
                paymentData = {
                    billing: 'annual',
                    product: this.selectedSize,
                    provider: this.selectedProvider
                }
            }

            return paymentManager.getSlugHelper().getYearlyAmountSavedForAnnual(paymentData, this.currency);
        },
        amountSavedForAnnualSale() {
            if (projectHelper.isApi2Convert()) {
                return '';
            }

            /** @type {PaymentData} */
            const paymentData = {};

            paymentData.billing = 'annual_%currency%_%version%_sale_cyberweek';
            paymentData.product = this.selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getYearlyAmountSavedForAnnualSale(paymentData, this.currency);
        },
        saveBadgeText() {
            return translate('Save %amount%', {
                '%amount%': this.amountSavedForAnnualSale,
            });
        },
        saleEnd() {
            return satGlobals.getSaleEnd();
        },
    },
    methods: {
        getPriceStringForBillingAndProduct(billing, product) {
            /** @type {PaymentData} */
            let paymentData = {};

            if (satGlobals.isMultipleProductsEnabled()) {
                paymentData = {
                    billing,
                    product: this.selectedProductStore,
                    plan: 'individual'
                };
            } else if (satGlobals.isCreditsInAllSatsEnabled()) {
                paymentData = {
                    billing,
                    product: this.selectedProductStore,
                    quota: this.selectedQuotaStore,
                    plan: 'individual'
                };
            } else {
                paymentData = {
                    billing,
                    product: product ?? this.selectedSize,
                    provider: this.selectedProvider
                };
            }

            return paymentManager.getSlugHelper().getPriceString(paymentData, this.currency);
        },
    },
    data() {
        return {
            selectedBilling: 'annual',
            selectedProduct: 'pro',
            learnMoreYear: false,
            learnMoreYearSale: false,
            learnMoreMonth: false,
            learnMoreDay: false,
            isOc: projectHelper.isOnlineConvert(),
            showWeekPass: satGlobals.isWeekPassEnabled(),
        };
    },
};
</script>

<style lang="scss">
.select-billing-item-wrapper {
    // needed when .select-billing-item is in its own line - basically just gets rid of the negative margin after wrapping
    padding-right: calc(1rem + 26px);
}

.select-billing-item-right-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    height: 8vh;
}
.select-billing-item {
    // negate margin-left of .select-billing-learn-more-link to make sure the elements don't wrap/line-break too early
    margin-right: calc(-1rem - 26px);
}
.select-billing-learn-more-link {
    // margin-left to make sure the learn more link is aligned with the start of the text when line breaking (mobile)
    // 1rem = padding-left of label; 16px = width of radio input; 10px = margin between radio input and label text
    margin-left: calc(1rem + 26px);

    // negate margin-right of .select-billing-item-wrapper if in the same line as .select-billing-item
    margin-right: calc(-1rem - 26px);
}

.select-billing-learn-more-box {
    top: 100%;
    z-index: 10;
}

b {
    color: white !important;
}

.flip-card__bottom,
.flip-card__back::before,
.flip-card__back-bottom,
.flip-card__top,
.flip-clock__card.flip-card,
.flip-card__back {
    color: white !important;
    font-size: 2rem !important;
}
</style>
